// extracted by mini-css-extract-plugin
module.exports = {"typographyText":"DisclosureWithText_typographyText__LCZ9n","disclosureButton":"DisclosureWithText_disclosureButton__neGn6"};